module.exports = __webpack_public_path__ + "img/GS_Profile-Dipuo Qholosha.1b7fba56.png";